import { v4 } from 'uuid'

import {
  ADD_FILE_SUCCESS,
  CREATE_CLAIM,
  CREATE_CLAIM_ERROR,
  CREATE_CLAIM_SUCCESS,
  GET_CLAIM_REASONS_BY_TYPE_ID,
  GET_CLAIM_REASONS_BY_TYPE_ID_ERROR,
  GET_CLAIM_REASONS_BY_TYPE_ID_SUCCESS,
  GET_CLAIM_TYPES,
  GET_CLAIM_TYPES_ERROR,
  GET_CLAIM_TYPES_SUCCESS,
  GET_ORGANIZATION_BY_DNI,
  GET_ORGANIZATION_BY_DNI_ERROR,
  GET_ORGANIZATION_BY_DNI_SUCCESS,
  GET_ORGANIZATION_BY_PROCESS_CODE,
  GET_ORGANIZATION_BY_PROCESS_CODE_ERROR,
  GET_ORGANIZATION_BY_PROCESS_CODE_SUCCESS,
  REMOVE_FILE_SUCCESS,
  RESET_FORM_ERRORS,
  RESET_ORGANIZATION,
  RESET_ORGANIZATION_ORG_NAME
} from './Claims.actions'

const clearError = slice => ({
  ...slice,
  error: null
})

const requestStart = slice => ({
  ...slice,
  error: null,
  loading: true
})

const requestError = (slice, error) => ({
  ...slice,
  error,
  loading: false
})

const requestSuccess = (slice, data) => ({
  ...slice,
  data,
  error: null,
  loading: false
})

const initialOrganizationState = {
  data: {
    dni: '',
    name: ''
  },
  disabledIfFound: true,
  error: null,
  loading: false,
  loadingOrgName: false
}

const initialState = {
  attachedFiles: [],
  claimReasons: {
    data: [],
    error: null,
    loading: false
  },
  claimTypes: {
    data: [],
    error: null,
    loading: true
  },
  organization: initialOrganizationState,
  submit: {
    code: '',
    error: null,
    loading: false,
    success: false
  }
}

/**
 * The Claims reducer.
 */
export const claimsReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case ADD_FILE_SUCCESS: {
      return {
        ...state,
        attachedFiles: state.attachedFiles.concat({ id: v4(), ...payload })
      }
    }
    case CREATE_CLAIM: {
      return {
        ...state,
        submit: { ...requestStart(state.submit), success: false }
      }
    }
    case CREATE_CLAIM_ERROR: {
      return {
        ...state,
        submit: { ...requestError(state.submit, payload.error), success: false }
      }
    }
    case CREATE_CLAIM_SUCCESS: {
      return {
        ...state,
        submit: { ...requestSuccess(state.submit, undefined), code: payload.code, success: true }
      }
    }

    case GET_CLAIM_REASONS_BY_TYPE_ID: {
      return { ...state, claimReasons: requestStart(state.claimReasons) }
    }
    case GET_CLAIM_REASONS_BY_TYPE_ID_ERROR: {
      return { ...state, claimReasons: requestError(state.claimReasons, payload.error) }
    }
    case GET_CLAIM_REASONS_BY_TYPE_ID_SUCCESS: {
      return { ...state, claimReasons: requestSuccess(state.claimReasons, payload.claimReasons) }
    }

    case GET_CLAIM_TYPES: {
      return { ...state, claimTypes: requestStart(state.claimTypes) }
    }
    case GET_CLAIM_TYPES_ERROR: {
      return { ...state, claimTypes: requestError(state.claimTypes, payload.error) }
    }
    case GET_CLAIM_TYPES_SUCCESS: {
      return { ...state, claimTypes: requestSuccess(state.claimTypes, payload.claimTypes) }
    }

    case GET_ORGANIZATION_BY_DNI: {
      return {
        ...state,
        organization: {
          ...state.organization,
          data: {
            ...state.organization.data,
            name: ''
          },
          error: null,
          loadingOrgName: true
        }
      }
    }
    case GET_ORGANIZATION_BY_DNI_ERROR: {
      return {
        ...state,
        organization: { ...state.organization, error: payload.error, loadingOrgName: false }
      }
    }
    case GET_ORGANIZATION_BY_DNI_SUCCESS: {
      return {
        ...state,
        organization: {
          ...state.organization,
          data: payload.organization,
          loadingOrgName: false
        }
      }
    }

    case GET_ORGANIZATION_BY_PROCESS_CODE: {
      return { ...state, organization: requestStart(state.organization) }
    }
    case GET_ORGANIZATION_BY_PROCESS_CODE_ERROR: {
      return {
        ...state,
        organization: { ...initialOrganizationState, error: payload.error }
      }
    }
    case GET_ORGANIZATION_BY_PROCESS_CODE_SUCCESS: {
      return {
        ...state,
        organization: {
          ...requestSuccess(state.organization, payload.organization),
          disabledIfFound: payload.disabledIfFound
        }
      }
    }

    case REMOVE_FILE_SUCCESS: {
      return {
        ...state,
        attachedFiles: state.attachedFiles.filter(file => file.id !== payload.id)
      }
    }

    case RESET_FORM_ERRORS: {
      return {
        ...state,
        attachedFiles: [],
        claimReasons: clearError(state.claimReasons),
        claimTypes: clearError(state.claimTypes),
        organization: clearError(state.organization),
        submit: clearError(state.submit)
      }
    }

    case RESET_ORGANIZATION: {
      return { ...state, organization: initialOrganizationState }
    }

    case RESET_ORGANIZATION_ORG_NAME: {
      return {
        ...state,
        organization: {
          ...state.organization,
          data: {
            ...state.organization.data,
            name: ''
          }
        }
      }
    }

    default: {
      return state
    }
  }
}
